import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import React, { FC, useEffect } from "react";

import {
  resetErrors,
  requestSelector,
} from "common/responseHandlerService/slice";
import { LoginDataT } from "./types";
import AuthActions from "../store/actions";
import { SignInSchema } from "./validations";
import { useAppDispatch, useAppSelector } from "application/store";

import PrimaryInput from "application/components/PrimaryInput";
import PrimaryButton from "application/components/PrimaryButton";

import {
  AuthTitle,
  AuthContent,
  AuthWrapper,
  AuthContainer,
  AuthInputWrapper,
} from "../styles";

const Login: FC = () => {
  const dispatch = useAppDispatch();
  const {
    signIn: { loading, error },
  } = useAppSelector(requestSelector);

  const {
    register,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginDataT>({
    resolver: yupResolver(SignInSchema),
  });

  const onSubmit = (data: LoginDataT) => {
    dispatch(resetErrors());
    dispatch(AuthActions.singIn(data));
  };

  useEffect(() => {
    if (error) {
      setError("email", { message: error });
      setError("password", { message: error });
    }
  }, [error]);

  useEffect(() => {
    return () => {
      dispatch(resetErrors());
    };
  }, []);

  return (
    <>
      <AuthWrapper>
        <AuthContainer>
          <AuthContent>
            <AuthTitle>Login</AuthTitle>

            <AuthInputWrapper>
              <PrimaryInput
                id="email"
                register={register}
                label="Email Address"
                placeholder="Email Address"
                error={errors.email?.message}
              />
            </AuthInputWrapper>

            <AuthInputWrapper>
              <PrimaryInput
                id="password"
                type="password"
                label="Password"
                register={register}
                placeholder="Password"
                error={errors.password?.message}
              />
            </AuthInputWrapper>
            <PrimaryButton
              title="Log in"
              loading={loading}
              onClick={handleSubmit(onSubmit)}
            />
          </AuthContent>
        </AuthContainer>
      </AuthWrapper>
    </>
  );
};

export default Login;
